import React from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';
import { IoClose, IoSearch } from 'react-icons/io5';

import { Button, FormInput } from 'modules/common/input';

function ProductSearch({
  value,
  className,
  onChange,
  name,
  placeholder,
  onSubmit,
  isLoading,
  isDisabled,
  enableSearchLabelInMobile,
  ...rest
}) {
  const handleOnSubmit = (overrideValue) => {
    onSubmit((prevState) => ({
      ...prevState,
      [name]: overrideValue ?? value,
    }));
  };
  const handleOnChange = (v) => {
    onChange((prevState) => ({
      ...prevState,
      ...v(),
    }));
  };

  return (
    <form
      className="flex items-center"
      onSubmit={(e) => {
        e.preventDefault();
        handleOnSubmit();
      }}
      autoComplete="off"
      noValidate
    >
      <div className="flex-1">
        <FormInput
          label=""
          placeholder={placeholder}
          {...rest}
          className={cn('rounded-r-none flex-1', className)}
          value={value}
          onChange={handleOnChange}
          name={name}
          disabled={isDisabled}
          icon={
            value?.length > 0 && (
              <IoClose
                className="h-5 w-5 cursor-pointer"
                onClick={() => {
                  handleOnSubmit('');
                }}
              />
            )
          }
          disableIconInputFocus
        />
      </div>

      <div>
        <Button
          label={
            !enableSearchLabelInMobile ? (
              <IoSearch className="h-5 w-5" />
            ) : (
              <>
                <span className="md:hidden font-medium">Search</span>
                <span className="hidden md:block">
                  <IoSearch className="h-5 w-5" />
                </span>
              </>
            )
          }
          className="btn outline text-black focus:bg-gray-50 border rounded border-l-0 rounded-l-none border-gray-400 border-opacity-60"
          onClick={() => handleOnSubmit()}
          isLoading={isLoading}
          disabled={isDisabled || value?.length <= 0}
        />
      </div>
    </form>
  );
}

ProductSearch.defaultProps = {
  value: '',
  className: '',
  placeholder: '',
  isLoading: false,
  isDisabled: false,
  enableSearchLabelInMobile: false,
  onChange: () => {},
  onSubmit: () => {},
};

ProductSearch.propTypes = {
  value: PropTypes.string,
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
  enableSearchLabelInMobile: PropTypes.bool,
  placeholder: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.instanceOf(Function),
  onSubmit: PropTypes.instanceOf(Function),
};

export default ProductSearch;
